import * as React from "react";
import { Box, Flex, Icon, chakra } from "@chakra-ui/react";
import { ReactDatePickerCustomHeaderProps } from "react-datepicker";
import { getMonth, getYear } from "date-fns";
import { SiChevronLeft, SiChevronRight } from "@medstonetech/slate-icons";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function CalendarHeader({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}: ReactDatePickerCustomHeaderProps): React.ReactElement {
  return (
    <Box mx="15px" mb="10px" mt="6px">
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          <chakra.button
            type="button"
            aria-label="Previous month"
            disabled={prevMonthButtonDisabled}
            onClick={decreaseMonth}
          >
            <Icon as={SiChevronLeft} fontSize="1rem" />
          </chakra.button>
          <chakra.span
            fontSize="20px"
            fontWeight="bold"
            minW="120px"
            textAlign="center"
          >
            {months[getMonth(date)]}
          </chakra.span>
          <chakra.button
            type="button"
            aria-label="Next month"
            disabled={nextMonthButtonDisabled}
            onClick={increaseMonth}
          >
            <Icon as={SiChevronRight} fontSize="1rem" />
          </chakra.button>
        </Flex>
        <Flex alignItems="center">
          <chakra.button
            type="button"
            aria-label="Previous year"
            disabled={prevYearButtonDisabled}
            onClick={decreaseYear}
          >
            <Icon as={SiChevronLeft} fontSize="1rem" />
          </chakra.button>
          <chakra.span
            fontSize="20px"
            fontWeight="bold"
            minW="60px"
            textAlign="center"
          >
            {getYear(date)}
          </chakra.span>
          <chakra.button
            type="button"
            aria-label="Next year"
            disabled={nextYearButtonDisabled}
            onClick={increaseYear}
          >
            <Icon as={SiChevronRight} fontSize="1rem" />
          </chakra.button>
        </Flex>
      </Flex>
    </Box>
  );
}

CalendarHeader.displayName = "CalendarHeader";

export { CalendarHeader };
